// Fonts (self-hosted, no CDN — required by the design handoff's strict CSP).
// See design_handoff_rev9_portal/README.md §"Fonts".
import '@fontsource-variable/fraunces';
import '@fontsource-variable/fraunces/wght-italic.css';
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';

import './styles/globals.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';

// Theme + density attributes live on <html> so CSS variables flip cleanly.
// See design_handoff_rev9_portal/starter/CLAUDE.md §"Token usage".
document.documentElement.dataset.mode = 'light';
document.documentElement.dataset.density = 'regular';

// Appearance ('clean' SaaS skin vs editorial) is read pre-paint so the
// first render already matches the saved preference — no flash. The
// PreferencesProvider keeps it in sync afterwards.
import { APPEARANCE_STORAGE_KEY } from './lib/preferences';
try {
  // Clean (professional SaaS sidebar) is the default; only editorial is opt-out.
  if (localStorage.getItem(APPEARANCE_STORAGE_KEY) !== 'editorial') {
    document.documentElement.dataset.view = 'clean';
  }
} catch { document.documentElement.dataset.view = 'clean'; }

// Site-wide: scrolling the mouse wheel over a focused <input type="number">
// silently increments/decrements its value — a well-known browser quirk
// nobody actually wants (every number field here — amounts, units, prices —
// is always typed manually). Blur the field on wheel so the page scrolls
// normally instead. Paired with the spinner-arrow removal in globals.css.
document.addEventListener('wheel', () => {
  const el = document.activeElement;
  if (el instanceof HTMLInputElement && el.type === 'number') {
    el.blur();
  }
}, { passive: true });

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
